import { render } from "./BlockContent.vue?vue&type=template&id=38938852"
import script from "./BlockContent.vue?vue&type=script&lang=js"
export * from "./BlockContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__